import { render, staticRenderFns } from "./ModuleAdd.vue?vue&type=template&id=9b639bf0&scoped=true"
import script from "./ModuleAdd.vue?vue&type=script&lang=js"
export * from "./ModuleAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b639bf0",
  null
  
)

export default component.exports